import {
  CourseQuestion,
  QuestionType,
} from '../jumpstart-communicator/jumpstart-communicator.types';

export const course_questions: CourseQuestion[] = [
  {
    id: 'b55df41c-62b5-4901-9ae7-a7e0118830f3',
    question: 'What is the main benefit of teamwork ?', //na
    type: QuestionType.RADIO,
    options: [
      {
        id: '512db95e-e361-4f31-bf56-406b57951218',
        option: 'Increased individual recognition',
      },
      {
        id: '03a4a060-e3e1-48c3-b7cf-92304e029596',
        option: 'More efficient problem-solving',
      },
      {
        id: 'ada79e0c-c813-44c0-898a-b30dcc804dfe',
        option: 'Less need for communication',
      },
      {
        id: '004dbf9a-666f-4a01-b621-0a6e11817e80',
        option: 'Reduced workload for everyone',
      },
    ],
    answers: ['004dbf9a-666f-4a01-b621-0a6e11817e80'],
    answer_description: 'That’s correct.',
    wrong_answer_description: "That's incorrect",

    chapter_id: 'b2234295-2cc4-4eed-a05e-822bacb1090c',
    course_id: '18473415-771b-431d-9d95-3e5dff0c9a17',
  },
  {
    id: '38f7feb9-d22f-4b4d-9247-40f7802079e1',
    question: 'What are some common settings where teamwork is important?', //A
    type: QuestionType.RADIO,
    options: [
      {
        id: 'ecfd9fd9-db9b-4386-a789-3e822e7d6262',
        option: 'School, sports, and home',
      },
      {
        id: '10f55080-508f-4f40-96ec-67d192949092',
        option: 'Traveling, shopping, and home',
      },
      {
        id: '05fdf9f0-4649-4ace-a7da-5e3e738fb782',
        option: 'Solo activities, reading, and exercising',
      },
      {
        id: 'ce379a9e-4604-45a5-8acd-a6f0585c9177',
        option: 'Watching TV, eating, and sleeping',
      },
    ],
    answers: ['ecfd9fd9-db9b-4386-a789-3e822e7d6262'],
    answer_description: 'That’s correct.',
    wrong_answer_description: "That's incorrect",

    chapter_id: 'b2234295-2cc4-4eed-a05e-822bacb1090c',
    course_id: '18473415-771b-431d-9d95-3e5dff0c9a17',
  },
  {
    id: '704a2827-9761-416d-8732-88d483d80b01',
    question: 'What is a key characteristic of great teams?', //a
    type: QuestionType.RADIO,
    options: [
      {
        id: '7e326278-df18-4250-9c22-29bda699cf30',
        option: 'Everyone has the same skills',
      },
      {
        id: '775f3e36-29a9-4ed2-bd29-1a2b240321f4',
        option: 'All team members are leaders',
      },
      {
        id: 'f5537e2b-21c9-4ab9-8247-9f24bb55c52c',
        option: 'Good communication and shared vision',
      },
      {
        id: '1417fd7d-2151-4232-9f2f-9e00c49bf3ee',
        option: 'Individual recognition is prioritized',
      },
    ],
    answers: ['f5537e2b-21c9-4ab9-8247-9f24bb55c52c'],
    answer_description: 'That’s correct.',
    wrong_answer_description: "That's incorrect",

    chapter_id: 'b2234295-2cc4-4eed-a05e-822bacb1090c',
    course_id: '18473415-771b-431d-9d95-3e5dff0c9a17',
  },
  {
    id: '89d77e14-20fc-4515-8bea-8bc226e87d7c',
    question: 'What does having a positive attitude in a team help with?', //a
    type: QuestionType.RADIO,
    options: [
      {
        id: '070428ea-d4fc-4f49-89ad-802b7872c6af',
        option: 'Reducing work quality',
      },
      {
        id: 'cf01cc66-bc87-4fb1-8947-e708c901b996',
        option: 'Building a supportive environment and improving problem-solving',
      },
      {
        id: 'e3b8cbf1-986f-46dd-a46b-aab38908b984',
        option: 'Limiting communication',
      },
      {
        id: '1b09d6df-85b6-40e0-bb7d-c3ce8cb0eb5e',
        option: 'Increasing individual workload',
      },
    ],
    answers: ['cf01cc66-bc87-4fb1-8947-e708c901b996'],
    answer_description: 'That’s correct.',
    wrong_answer_description: "That's incorrect",

    chapter_id: 'b2234295-2cc4-4eed-a05e-822bacb1090c',
    course_id: '18473415-771b-431d-9d95-3e5dff0c9a17',
  },
  {
    id: 'cadc0962-0f7f-4c4e-bae2-13eb941f3e04',
    question: 'What is the ultimate goal of teamwork?', //a
    type: QuestionType.RADIO,
    options: [
      {
        id: '7b9807c5-c9c4-4c98-be32-f5f8323572c2',
        option: 'To create synergy where collective efforts result in greater achievements',
      },
      {
        id: '58e223b0-faca-4488-9822-ee3a0d56a6c2',
        option: 'To allow individuals to shine more than the team',
      },
      {
        id: '26295598-d100-4009-ba84-fc1bf616a4ba',
        option: 'To reduce the number of people needed for tasks',
      },
      {
        id: '6e84237e-119f-4694-ac6e-a8f684024deb',
        option: 'To focus solely on individual success',
      },
    ],
    answers: ['7b9807c5-c9c4-4c98-be32-f5f8323572c2'],
    answer_description: 'That’s correct.',
    wrong_answer_description: "That's incorrect",

    chapter_id: 'b2234295-2cc4-4eed-a05e-822bacb1090c',
    course_id: '18473415-771b-431d-9d95-3e5dff0c9a17',
  },
  {
    id: '1d4bf995-b974-482d-b455-a0bb3b85b0f6', //a
    question:
      'Scenario: You are working on a school project with a group of classmates. You all have different ideas on how to approach the project. What is the best way to handle this situation?',
    type: QuestionType.RADIO,
    options: [
      {
        id: '1d3c03f0-6c16-42ea-ba37-24fc1079f54e',
        option: 'Ignore everyone else’s ideas and do it your way.',
      },
      {
        id: '04a961a6-68bd-4d6b-84a2-879eaf238ea5',
        option: 'Discuss each idea as a group and decide on the best approach together.',
      },
      {
        id: '0a89d610-06a5-431d-860f-4baa76b3015c',
        option: 'Let one person decide or the entire group.',
      },
      {
        id: '303c3c5a-d7cd-4b17-a32d-dd1a4d3a9426',
        option: 'Split the project and work on dierent parts separately without communicating.',
      },
    ],
    answers: ['04a961a6-68bd-4d6b-84a2-879eaf238ea5'],
    answer_description: 'That’s correct.',
    wrong_answer_description: "That's incorrect",

    chapter_id: 'b2234295-2cc4-4eed-a05e-822bacb1090c',
    course_id: '18473415-771b-431d-9d95-3e5dff0c9a17',
  },
  {
    id: 'c1fe0c91-774a-4c20-ab8c-94012456d3a9', //a
    question:
      'Scenario: You have been assigned to a team at work to complete a project. One of your team members consistently misses deadlines, which affects the entire team’s progress. How should you address this issue?',
    type: QuestionType.RADIO,
    options: [
      {
        id: '24f70c56-f25b-4ad5-8794-9995f86d748f',
        option: 'Complain to your boss about the team member.',
      },
      {
        id: '8bf200bb-567b-4e5e-816a-d5ee51039f76',
        option:
          'Offer to help the team member with their tasks and find out if they need any support. ',
      },
      {
        id: 'fd4f5344-7217-4d3f-bbdd-d06eadd079d9',
        option: 'Do all their work for them to ensure deadlines are met.',
      },
      {
        id: 'c3300e5c-d861-4116-9cec-d66da76e2d0b',
        option: 'Ignore the issue and hope it gets better.',
      },
    ],
    answers: ['8bf200bb-567b-4e5e-816a-d5ee51039f76'],
    answer_description: 'That’s correct.',
    wrong_answer_description: "That's incorrect",

    chapter_id: 'b2234295-2cc4-4eed-a05e-822bacb1090c',
    course_id: '18473415-771b-431d-9d95-3e5dff0c9a17',
  },
  {
    id: '949e87ee-f65d-4d0f-afdd-61a939fef859', //a
    question:
      'Scenario: During a team meeting, you see that one team member is very quiet and seems uncomfortable. How can you engage them effectively?',
    type: QuestionType.RADIO,
    options: [
      {
        id: 'fb8af8bc-d116-47f1-9feb-602e367a6002',
        option: 'Ignore them since they are quiet.',
      },
      {
        id: '69cf8255-0ac2-4bb5-bc87-33f24eff4ef7',
        option: 'Assume they have nothing to contribute.',
      },
      {
        id: 'c48041f8-4b32-43f2-ba2d-0b20e4baf702',
        option: 'Directly ask them for their input and make them feel included.',
      },
      {
        id: '6692a7a7-d7da-4531-8360-76117f0c04d7',
        option: 'Continue the meeting without involving them.',
      },
    ],
    answers: ['c48041f8-4b32-43f2-ba2d-0b20e4baf702'],
    answer_description: 'That’s correct.',
    wrong_answer_description: "That's incorrect",

    chapter_id: 'b2234295-2cc4-4eed-a05e-822bacb1090c',
    course_id: '18473415-771b-431d-9d95-3e5dff0c9a17',
  },
  {
    id: '123d71fb-99c0-480b-97e2-cb26e064a0d9', //a
    question: 'Which role in a team focuses on keeping morale high and bringing fun to the team?',
    type: QuestionType.RADIO,
    options: [
      {
        id: 'ea913fee-a0f1-49c7-8ef0-b7d888d0420f',
        option: 'Organizaer',
      },
      {
        id: '90ba6b90-7ea1-4233-aaa6-ebbc54f7879a',
        option: 'Inspirer',
      },
      {
        id: '7fd9c20e-5082-456d-ac34-e1bff4c893c0',
        option: 'Visionary',
      },
      {
        id: '333a5679-ef1c-49b3-b286-ac3867f8e878',
        option: 'Carer',
      },
    ],
    answers: ['90ba6b90-7ea1-4233-aaa6-ebbc54f7879a'],
    answer_description: 'That’s correct.',
    wrong_answer_description: "That's incorrect",

    chapter_id: 'b2234295-2cc4-4eed-a05e-822bacb1090c',
    course_id: '18473415-771b-431d-9d95-3e5dff0c9a17',
  },
  {
    id: '1d723ba7-731b-4329-8d60-a9ebdf868548', //a
    question: 'What is one way to manage a weakness in a team setting?',
    type: QuestionType.RADIO,
    options: [
      {
        id: 'b51f6cb5-1567-4cf8-be10-b66e838ebaf3',
        option: 'Ignore it completely.',
      },
      {
        id: '62f411ae-0eb8-4b8d-8e74-a73af4207006',
        option: 'Avoid tasks that highlight it.',
      },
      {
        id: '22aeb628-441b-4b95-ae3e-933c3d9e30ac',
        option: 'Blame others for it',
      },
      {
        id: '248fe273-764f-4d5b-9fef-c03f1a29db80',
        option: 'Pretnd it dosen’t exist',
      },
    ],
    answers: ['62f411ae-0eb8-4b8d-8e74-a73af4207006'],
    answer_description: 'That’s correct.',
    wrong_answer_description: "That's incorrect",

    chapter_id: 'b2234295-2cc4-4eed-a05e-822bacb1090c',
    course_id: '18473415-771b-431d-9d95-3e5dff0c9a17',
  },
  {
    id: 'd44bee81-72fe-4a95-9a1d-075877a1bbad', //a
    question: 'What is the ultimate goal of teamwork?',
    type: QuestionType.RADIO,
    options: [
      {
        id: '86916a77-b28c-442c-98cb-b1c0793b86ad',
        option: 'To create synergy where collective efforts result in greater achievements.',
      },
      {
        id: '9e280a63-99f1-4a93-99b7-a9e93c97a833',
        option: 'To allow individuals to shine more than the team.',
      },
      {
        id: 'e1fd8241-8797-4875-b68f-07121ab75667',
        option: 'To reduce the number of people needed for tasks.',
      },
      {
        id: '64badab3-5ada-4de2-a983-61ae11d1307a',
        option: 'To focus solely on individual success.',
      },
    ],
    answers: ['86916a77-b28c-442c-98cb-b1c0793b86ad'],
    answer_description: 'That’s correct.',
    wrong_answer_description: "That's incorrect",

    chapter_id: 'b2234295-2cc4-4eed-a05e-822bacb1090c',
    course_id: '18473415-771b-431d-9d95-3e5dff0c9a17',
  },
  {
    id: 'd579dd0b-b06d-4c8c-8c5b-ddf5d204180f', //a
    question:
      'Scenario: Your team has been assigned a large task that needs to be broken down into smaller tasks. As the team leader, how should you decide who does what?',
    type: QuestionType.RADIO,
    options: [
      {
        id: '9f4cd7c6-1a0f-430a-afc6-589fcad7924c',
        option: 'Assign tasks randomly to team members.',
      },
      {
        id: '18710073-b8d4-4eeb-ba2b-9e8f8149f750',
        option: 'Let team members choose their tasks based on their preferences and strenghts. ',
      },
      {
        id: 'e6d8a8ec-a2a5-4055-ae6d-4cf30c9e1537',
        option:
          'Assign the hardest tasks to the most capable team members and the easiest tasks to everyone else. ',
      },
      {
        id: '259b30d5-8640-4ffa-891a-15c80439fff6',
        option: 'Do all the work yourself to ensure it’s done correctly.',
      },
    ],
    answers: ['18710073-b8d4-4eeb-ba2b-9e8f8149f750'],
    answer_description: 'That’s correct.',
    wrong_answer_description: "That's incorrect",

    chapter_id: 'b2234295-2cc4-4eed-a05e-822bacb1090c',
    course_id: '18473415-771b-431d-9d95-3e5dff0c9a17',
  },
  {
    id: '0eec28ef-5807-4276-aeea-2d9703865ccc', //a
    question: 'Which type of trust is based on the belief in someone’s skills and abilities?',
    type: QuestionType.RADIO,
    options: [
      {
        id: '069be726-2ab1-490d-b2f0-7fb04d3869c6',
        option: 'Emotional trust',
      },
      {
        id: 'd929f4fa-3ff8-4a93-a353-6dc80eab99cd',
        option: 'Integrity-based trust',
      },
      {
        id: 'd82698eb-721e-4945-a06a-4bf5c207c095',
        option: 'Competence-based trust',
      },
      {
        id: '63388ec8-d312-43fc-a9e1-87a6c083b2ac',
        option: 'Reliance trust',
      },
    ],
    answers: ['d82698eb-721e-4945-a06a-4bf5c207c095'],
    answer_description: 'That’s correct.',
    wrong_answer_description: "That's incorrect",

    chapter_id: 'b2234295-2cc4-4eed-a05e-822bacb1090c',
    course_id: '18473415-771b-431d-9d95-3e5dff0c9a17',
  },
  {
    id: '258f0fa1-ae38-4cf1-86a4-856bf06bb812', //a
    question: 'What is psychological safety in a team setting?',
    type: QuestionType.RADIO,
    options: [
      {
        id: '7e8ea0aa-1bc0-481d-98f8-8a1bde5b32ac',
        option: 'Ensuring physical safety during tasks',
      },
      {
        id: 'c8ed0fbf-d66c-4d91-9c61-3c676ae03af6',
        option: 'Feeling that one can speak freely without fear of judgement or critcism',
      },
      {
        id: 'b4fc7aa7-4137-4a78-a6fa-470732512679',
        option: 'Having a quiet and calm working environment',
      },
      {
        id: '1615241c-ec55-41c2-9130-fafc35ce8f57',
        option: 'Having strict rules and regulations to follow',
      },
    ],
    answers: ['c8ed0fbf-d66c-4d91-9c61-3c676ae03af6'],
    answer_description: 'That’s correct.',
    wrong_answer_description: "That's incorrect",

    chapter_id: 'b2234295-2cc4-4eed-a05e-822bacb1090c',
    course_id: '18473415-771b-431d-9d95-3e5dff0c9a17',
  },
  {
    id: '7945df06-b855-4c38-9b9d-53deab522a01', //a
    question: 'What is team culture?',
    type: QuestionType.RADIO,
    options: [
      {
        id: 'e55eacd9-8402-4136-a2ff-0f1b636cac95',
        option: 'The hierarchical structure of a team',
      },
      {
        id: 'eb2ee8a2-1fae-4568-9a8f-63e2cfb8a69d',
        option: 'The shared values, behaviors, and traditions that shape a team’s overall vibe',
      },
      {
        id: '480bb719-33c9-4adb-8e8a-230ed63346c4',
        option: 'The individual achievements of team members',
      },
      {
        id: '3ab105b5-76da-4e62-90f7-ec94169b3ed6',
        option: 'The physical environment where the team works',
      },
    ],
    answers: ['eb2ee8a2-1fae-4568-9a8f-63e2cfb8a69d'],
    answer_description: 'That’s correct.',
    wrong_answer_description: "That's incorrect",

    chapter_id: 'b2234295-2cc4-4eed-a05e-822bacb1090c',
    course_id: '18473415-771b-431d-9d95-3e5dff0c9a17',
  },
  {
    id: 'd10bbb4a-c512-4d4f-a948-7df38828372d', //a
    question:
      'Scenario: You’re part of a group project where the team is considering taking a big risk to meet a tight deadline. What might contribute to the team’s decision to take this risk? ',
    type: QuestionType.RADIO,
    options: [
      {
        id: '6fc52100-9e65-46e8-a73e-c935217fba5c',
        option: 'Each team member carefully weighs the pros and cons before deciding.',
      },
      {
        id: 'dc6cfcdc-697b-4a84-9de8-d85a5c770564',
        option: 'Team members feel less accountable for the decision if it goes wrong. ',
      },
      {
        id: 'ef9113de-cb59-44c2-9302-7783e6cc33e2',
        option: 'Team members are overly cautious and hesitant to take risks.',
      },
      {
        id: '1f651fa0-9094-4242-ac77-81a386677591',
        option: 'The team leader takes full responsibility for all decisions made.',
      },
    ],
    answers: ['dc6cfcdc-697b-4a84-9de8-d85a5c770564'],
    answer_description: 'That’s correct.',
    wrong_answer_description: "That's incorrect",

    chapter_id: 'b2234295-2cc4-4eed-a05e-822bacb1090c',
    course_id: '18473415-771b-431d-9d95-3e5dff0c9a17',
  },
];
